// extracted by mini-css-extract-plugin
module.exports = {"addToCartControl":"fv","giftCard":"gv","btnContainer":"hv","cartButton":"iv","disabled":"jv","stockMessage":"kv"};